var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-input',{staticClass:"mb-3",attrs:{"label":_vm.label,"placeholder":"YYYY/MM/DD","label-classes":_vm.labelClasses,"value":_vm.value,"name":_vm.name,"rules":_vm.rules,"error":_vm.error},on:{"input":_vm.process,"blur":_vm.normalize}})
}
var staticRenderFns = []

export { render, staticRenderFns }